import React from 'react';

type SvgProps = {
  strokeColor?: string;
};

const MyOrdersIcon: React.FC<SvgProps> = ({ strokeColor = '#CBD2D9' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6481 7.63867H30.6665L25.7852 20.4748H8.10236V25.311H24.1735"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.405 29.3318C11.2951 29.3318 12.0167 28.6236 12.0167 27.7499C12.0167 26.8762 11.2951 26.168 10.405 26.168C9.51487 26.168 8.79327 26.8762 8.79327 27.7499C8.79327 28.6236 9.51487 29.3318 10.405 29.3318Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M22.2855 29.3318C23.1757 29.3318 23.8973 28.6236 23.8973 27.7499C23.8973 26.8762 23.1757 26.168 22.2855 26.168C21.3954 26.168 20.6738 26.8762 20.6738 27.7499C20.6738 28.6236 21.3954 29.3318 22.2855 29.3318Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M1.33331 2.66602L4.05021 4.65472L8.10254 20.4739"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MyOrdersIcon;
